import { z } from 'zod';

import { QuestionnaireInstanceZod } from 'types/zod/questionnaire-instance';

export const ParticipantReferenceZod = z.object({
    qInstanceId: QuestionnaireInstanceZod.shape.questionnaire_instance_id,
    path: z.string(),
    role: z.string(),
});

export const ParticipantReferencesZod = z.record(z.number(), z.array(ParticipantReferenceZod));

export type ParticipantReference = z.infer<typeof ParticipantReferenceZod>;
export type ParticipantReferences = z.infer<typeof ParticipantReferencesZod>;
